import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const navLinks = [
  { label: "Home", path: "/" },
  { label: "About", path: "/about" },
  { label: "Services", path: "/services" },
  { label: "Sectors", path: "/sectors" },
  { label: "Team", path: "/team" },
  { label: "Insights", path: "/insights" },
  { label: "International", path: "/international" },
  { label: "Contact", path: "/contact" },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#0A1628]/98 backdrop-blur-sm shadow-lg" : "bg-[#0A1628]"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2 group" data-testid="logo-link">
            <div className="flex items-center gap-1.5">
              <div className="flex flex-col gap-[3px]">
                <div className="w-5 h-[2px] bg-[#C5A059] transition-all duration-300 group-hover:w-6"></div>
                <div className="w-5 h-[2px] bg-[#C5A059] transition-all duration-300 group-hover:w-6"></div>
              </div>
              <span className="font-heading text-white text-lg md:text-xl font-medium tracking-tight">
                Equaliser
              </span>
              <span className="text-white/50 text-lg md:text-xl font-light">Legal</span>
            </div>
          </Link>

          {/* Desktop Links */}
          <div className="hidden lg:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`nav-${link.label.toLowerCase()}`}
                className={`text-xs uppercase tracking-[0.15em] transition-colors duration-300 ${
                  location.pathname === link.path
                    ? "text-[#C5A059]"
                    : "text-white/70 hover:text-[#C5A059]"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Mobile Toggle */}
          <button
            data-testid="mobile-menu-toggle"
            className="lg:hidden text-white/80 hover:text-white"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            {mobileOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div data-testid="mobile-menu" className="lg:hidden bg-[#0A1628] border-t border-white/10">
          <div className="px-6 py-4 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                data-testid={`mobile-nav-${link.label.toLowerCase()}`}
                className={`block py-3 text-sm uppercase tracking-[0.15em] transition-colors duration-300 ${
                  location.pathname === link.path
                    ? "text-[#C5A059]"
                    : "text-white/70 hover:text-[#C5A059]"
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
}
